module.exports = __webpack_public_path__ + "static/media/search.ecef733a.svg";